import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import registerServiceWorker, {
  unregister as unregisterServiceWorker,
} from './registerServiceWorker';
import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL || 'http://localhost:60702';

// axios.defaults.headers.common['Authorization'] = 'AUTH TOKEN';
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.withCredentials = true;
axios.interceptors.request.use(request => {
    console.log(request);
    // Edit request config
    return request;
}, error => {
    console.log(error);
    return Promise.reject(error);
});

axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response && error.response.status === 403) {
      const originalPath = window.location.pathname + window.location.search;

      sessionStorage.setItem("redirectAfterLogin", originalPath);

      window.location.href = "/testlogin";
    }
    return Promise.reject(error);
});

const app = (
        <BrowserRouter>
            <App/>
        </BrowserRouter>
)
ReactDOM.render(app, document.getElementById('root'));

if (process.env.NODE_ENV === 'production') {
  // Only register service worker in the actual production bundle
  registerServiceWorker();
} else {
  // In dev, make sure any old SW is unregistered
  unregisterServiceWorker();
}

